import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_jrnl_batch_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  system: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  batch_date: fromDatatype.TimestampTzDatatypeInterface;
  balance_type: fromDatatype.VarcharDatatypeInterface;
  jrnl_type: fromDatatype.VarcharDatatypeInterface;
  ctrl_total: fromDatatype.NumericDatatypeInterface;
  txn_count: fromDatatype.NumericDatatypeInterface;
  status_posting: fromDatatype.VarcharDatatypeInterface;
  status_fund: fromDatatype.VarcharDatatypeInterface;
  status_approval: fromDatatype.VarcharDatatypeInterface;
  posting_log_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_jrnl_batch_RowClass
  implements bl_fi_jrnl_batch_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  system: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  batch_date: fromDatatype.TimestampTzDatatypeInterface;
  balance_type: fromDatatype.VarcharDatatypeInterface;
  jrnl_type: fromDatatype.VarcharDatatypeInterface;
  ctrl_total: fromDatatype.NumericDatatypeInterface;
  txn_count: fromDatatype.NumericDatatypeInterface;
  status_posting: fromDatatype.VarcharDatatypeInterface;
  status_fund: fromDatatype.VarcharDatatypeInterface;
  status_approval: fromDatatype.VarcharDatatypeInterface;
  posting_log_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
